import React from 'react';
import { Box, Container } from '@mui/material';
import BookingWizard from './components/BookingWizard';

const BookingPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
      <Container sx={{ py: 8, maxWidth: 'lg' }}>
        <BookingWizard />
      </Container>
    </Box>
  );
};

export default BookingPage;
